export default function MuiTabs() {
	return {
		indicator: {
			height: '4px'
		}
	};
}
